import React from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Grid,
    Tooltip,
    TableContainer
} from '@material-ui/core';
import TablePager from '../../../components/atom/TablePager';
import { useModals } from '../../../hooks/useModal';
import { MODAL_TYPE } from '../../../hooks/useModal';
import ActionIconButton from '../../../components/atom/ActionIconButton';
import { EyeIcon, RotateLeftIcon } from '../../../icons';
import EmailStatusIcon from '../../../components/EmailStatusIcon';

const EMAIL_LOGS_COLUMNS = [
    { key: 'created_at', label: 'Date time' },
    { key: 'to', label: 'To' },
    { key: 'type', label: 'Type' },
    { key: 'subject', label: 'Subject' },
    {
        key: 'booking_item_id',
        label: 'Reservation ID',
        align: 'center',
        style: {
            whiteSpace: 'nowrap'
        }
    },
    { key: 'status', label: 'Status', align: 'center' },
    { key: 'result', label: 'Result' },
    { key: 'actions', label: 'Actions' }
];

const RenderColumns = ({ email, showModal, visibleColumns, disableResend, onResent }) => {
    return (
        <>
            {visibleColumns.map(column => {
                if (column.key === 'booking_item_id') {
                    return (
                        <TableCell key={column.key} align={column.align || 'left'}>
                            {email?.booking_item_id ? (
                                <a
                                    href={`/client/bookings/${email.booking_item_id}`}
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    {email.booking_item_id}
                                </a>
                            ) : (
                                '-'
                            )}
                        </TableCell>
                    );
                } else if (column.key === 'status') {
                    return (
                        <TableCell key={column.key} align={column.align || 'left'}>
                            <EmailStatusIcon status={email?.status} result={email?.result} />
                        </TableCell>
                    );
                } else if (column.key === 'result') {
                    return (
                        <TableCell key={column.key} align={column.align || 'left'}>
                            {email?.result !== 'success' && (
                                <Tooltip title={email?.result}>
                                    <small
                                        style={{
                                            display: '-webkit-box',
                                            WebkitBoxOrient: 'vertical',
                                            WebkitLineClamp: 3,
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            maxWidth: 300,
                                            wordBreak: 'break-word'
                                        }}
                                    >
                                        {email?.result}
                                    </small>
                                </Tooltip>
                            )}
                        </TableCell>
                    );
                } else if (column.key === 'actions') {
                    return (
                        <TableCell key={column.key} align={column.align || 'left'}>
                            {email.type === 'email' && (
                                <>
                                    <ActionIconButton
                                        title="Preview"
                                        icon={EyeIcon}
                                        onClick={() => {
                                            showModal(MODAL_TYPE.EMAIL_PREVIEW, {
                                                id: email.id
                                            });
                                        }}
                                    />
                                    {!disableResend && (
                                        <ActionIconButton
                                            title="Resend"
                                            icon={RotateLeftIcon}
                                            onClick={() => {
                                                showModal(MODAL_TYPE.RESEND_EMAIL_MODAL, {
                                                    initialEmail: email,
                                                    onResent
                                                });
                                            }}
                                        />
                                    )}
                                </>
                            )}
                        </TableCell>
                    );
                } else {
                    return (
                        <TableCell key={column.key} align={column.align || 'left'}>
                            {email[column.key]}
                        </TableCell>
                    );
                }
            })}
        </>
    );
};

const EmaillogTable = ({
    total = 0,
    emails = [],
    page,
    pageSize,
    setPage,
    setPageSize,
    disableResend = false,
    onResent,
    columnsToShow = [
        'created_at',
        'to',
        'type',
        'subject',
        'booking_item_id',
        'status',
        'result',
        'actions'
    ]
}) => {
    const { showModal } = useModals();

    const visibleColumns = EMAIL_LOGS_COLUMNS.filter(column => columnsToShow.includes(column.key));

    return (
        <>
            <TableContainer>
                <Table style={{ backgroundColor: 'white' }} size="small">
                    <TableHead>
                        <TableRow>
                            {visibleColumns.map(column => (
                                <TableCell
                                    key={column.key}
                                    align={column.align || 'left'}
                                    style={column?.style || {}}
                                >
                                    {column.label}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {emails.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={visibleColumns.length} align="center">
                                    No email logs found.
                                </TableCell>
                            </TableRow>
                        ) : (
                            emails.map(email => (
                                <TableRow key={email.id}>
                                    <RenderColumns
                                        email={email}
                                        showModal={showModal}
                                        disableResend={disableResend}
                                        visibleColumns={visibleColumns}
                                        onResent={onResent}
                                    />
                                </TableRow>
                            ))
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
            <Grid container justifyContent="flex-end">
                <TablePager
                    total={total}
                    page={page}
                    pageSize={pageSize}
                    setPage={setPage}
                    setPageSize={setPageSize}
                />
            </Grid>
        </>
    );
};

export default EmaillogTable;
